"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (event, check) {
  return {
    _isMBTransition: true,
    event: event,
    check: check
  };
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/dnd-multi-backend/lib/createTransition.js
// module id = 72
// module chunks = 0